import React from "react";
import { SvgIcon, SvgIconProps } from "@mui/material";

// TODO: move to atticus-shared
export const AtticusLogo = (props: SvgIconProps): JSX.Element => {
  return (
    <SvgIcon {...props}>
      <g clipPath="url(#clip0_2265_22962)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M44.1806 0.000480187C44.8322 0.0312663 45.4476 0.310006 45.9011 0.779821C46.3545 1.24964 46.612 1.87511 46.6209 2.52862C46.604 3.1813 46.3457 3.80442 45.8962 4.27714C45.4467 4.74985 44.838 5.03848 44.1881 5.08704C43.5164 5.0686 42.8765 4.79608 42.3972 4.32426C41.9178 3.85244 41.6345 3.21631 41.6042 2.54376C41.6102 1.86453 41.8848 1.21539 42.3677 0.738645C42.8507 0.261899 43.5026 -0.00355372 44.1806 0.000480187ZM99.2056 20.8349C99.5032 20.8349 99.7722 20.904 100.013 21.0423C100.256 21.1806 100.447 21.3715 100.585 21.6149C100.724 21.8554 100.793 22.1229 100.793 22.4175C100.793 22.7121 100.722 22.9826 100.581 23.2291C100.44 23.4726 100.247 23.665 100.004 23.8063C99.7602 23.9476 99.4912 24.0182 99.1966 24.0182C98.902 24.0182 98.633 23.9476 98.3895 23.8063C98.149 23.665 97.9581 23.4726 97.8168 23.2291C97.6786 22.9857 97.6094 22.7181 97.6094 22.4265C97.6094 22.135 97.6786 21.8674 97.8168 21.624C97.9581 21.3805 98.1505 21.1881 98.394 21.0468C98.6375 20.9055 98.908 20.8349 99.2056 20.8349ZM99.1966 23.8153C99.4551 23.8153 99.6896 23.7537 99.9 23.6304C100.11 23.5072 100.276 23.3389 100.396 23.1254C100.519 22.912 100.581 22.676 100.581 22.4175C100.581 22.159 100.521 21.9246 100.4 21.7141C100.283 21.5037 100.119 21.3384 99.909 21.2182C99.7016 21.0979 99.4671 21.0378 99.2056 21.0378C98.9471 21.0378 98.7111 21.0994 98.4977 21.2227C98.2873 21.3459 98.122 21.5142 98.0017 21.7277C97.8815 21.9381 97.8214 22.171 97.8214 22.4265C97.8214 22.6821 97.8815 22.9165 98.0017 23.1299C98.122 23.3404 98.2873 23.5072 98.4977 23.6304C98.7081 23.7537 98.9411 23.8153 99.1966 23.8153ZM100.013 22.138C100.013 22.2732 99.9796 22.389 99.9135 22.4852C99.8474 22.5814 99.7542 22.6505 99.6339 22.6926L100.044 23.3283H99.7331L99.3589 22.7512H99.2823H98.8674V23.3283H98.5608V21.5248H99.2823C99.5077 21.5248 99.6851 21.5804 99.8143 21.6916C99.9466 21.8028 100.013 21.9516 100.013 22.138ZM99.2597 22.4987C99.404 22.4987 99.5152 22.4671 99.5934 22.404C99.6745 22.3409 99.7151 22.2522 99.7151 22.138C99.7151 22.0237 99.6745 21.9366 99.5934 21.8765C99.5152 21.8133 99.404 21.7818 99.2597 21.7818H98.8629V22.4987H99.2597ZM37.612 2.98246V7.95548H45.9681V7.97819V23.6163H42.1527V11.1194H37.612V23.6163H33.8042V11.1194H29.0973V23.6163H25.2064V11.1194H21.8972V7.95548H25.2064V2.98246H29.0973V7.95548H33.8042V2.98246H37.612ZM77.0933 7.97069V15.7141C77.0933 19.8166 74.4263 20.6114 73.0059 20.6114C71.4344 20.6114 69.2887 19.5971 69.2887 16.0017V7.97069H65.5111V15.7141C65.5111 21.9814 68.2537 24.0403 72.4695 24.0403C73.3463 24.0651 74.2178 23.8962 75.0221 23.5456C75.8264 23.195 76.5439 22.6713 77.1235 22.0117V23.6088H80.9011V7.97069H77.0933ZM89.3483 7.41044C94.3498 7.41044 95.332 11.5206 95.332 11.5206L91.8264 12.3381C90.9953 9.93102 87.0137 10.3398 87.0137 12.2018C87.0137 13.4555 88.3569 13.741 89.9553 14.0807C92.3038 14.5798 95.2036 15.1961 95.2036 19.1731C95.2036 21.951 93.0277 24.0402 89.0914 24.0402C85.82 24.0402 83.2815 22.0267 82.8508 19.5667L86.4471 18.9839C86.9457 21.0881 91.5846 21.5726 91.5846 19.2337C91.5846 18.2266 90.3424 17.9189 88.8274 17.5437C86.4595 16.9573 83.425 16.2058 83.425 12.3608C83.425 11.1951 84.3467 7.41044 89.3483 7.41044ZM56.4468 20.7319C53.8176 20.7319 52.095 18.5292 52.095 15.8043C52.095 13.0794 53.8176 10.8691 56.4468 10.8691C57.2865 10.8623 58.1079 11.1143 58.7998 11.5909C59.4918 12.0675 60.0207 12.7456 60.3151 13.5335L63.7376 12.2846C63.167 10.8121 62.1538 9.55358 60.8383 8.68304C59.5227 7.81249 57.9697 7.37292 56.3939 7.4251C51.4981 7.4251 48.3098 11.8304 48.3098 15.7059C48.2837 16.7874 48.4733 17.8632 48.8674 18.8703C49.2616 19.8775 49.8524 20.7957 50.6053 21.5711C51.3582 22.3465 52.258 22.9636 53.252 23.3862C54.246 23.8088 55.3141 24.0284 56.3939 24.0321C57.8574 24.0808 59.3037 23.7053 60.5595 22.9507C61.8152 22.1961 62.8269 21.0946 63.4731 19.7782L60.1564 18.4308C59.8277 19.136 59.3028 19.7311 58.6448 20.1446C57.9867 20.5582 57.2235 20.7726 56.4468 20.7622V20.7319ZM17.4592 23.6172L22.1888 21.6113L13.6968 0.402158H8.49121L17.4592 23.6172Z"
          fill="#1B174F"
        />
        <path
          d="M0 21.5685L4.71266 23.5704L11.0691 7.11714L8.47524 0.401367L0 21.5685Z"
          fill="#01D9C6"
        />
      </g>
      <defs>
        <clipPath id="clip0_2265_22962">
          <rect width="100.8" height="24" fill="white" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
};

export const Home = (props: SvgIconProps): JSX.Element => {
  return (
    <SvgIcon {...props}>
      <path d="M8 17V11H12V17H17V9H20L10 0L0 9H3V17H8Z" fill="#2D2A5C" />
    </SvgIcon>
  );
};

export const FoldMap = (props: SvgIconProps): JSX.Element => {
  return (
    <SvgIcon {...props}>
      <path
        d="M17.5 0L17.34 0.03L12 2.1L6 0L0.36 1.9C0.15 1.97 0 2.15 0 2.38V17.5C0 17.78 0.22 18 0.5 18L0.66 17.97L6 15.9L12 18L17.64 16.1C17.85 16.03 18 15.85 18 15.62V0.5C18 0.22 17.78 0 17.5 0ZM12 16L6 13.89V2L12 4.11V16Z"
        fill="#2D2A5C"
      />
    </SvgIcon>
  );
};

export const Suitcase = (props: SvgIconProps): JSX.Element => {
  return (
    <SvgIcon {...props}>
      <path
        d="M18 4H14V2C14 0.89 13.11 0 12 0H8C6.89 0 6 0.89 6 2V4H2C0.89 4 0.00999999 4.89 0.00999999 6L0 17C0 18.11 0.89 19 2 19H18C19.11 19 20 18.11 20 17V6C20 4.89 19.11 4 18 4ZM12 4H8V2H12V4Z"
        fill="#2D2A5C"
      />
    </SvgIcon>
  );
};

export const Form = (props: SvgIconProps): JSX.Element => {
  return (
    <SvgIcon {...props}>
      <path
        d="M5 2H2V5H0V0H5V2ZM20 5V0H15V2H18V5H20ZM5 20H2V17H0V22H5V20ZM18 17V20H15V22H20V17H18ZM17 17C17 18.1 16.1 19 15 19H5C3.9 19 3 18.1 3 17V5C3 3.9 3.9 3 5 3H15C16.1 3 17 3.9 17 5V17ZM13 7H7V9H13V7ZM13 10H7V12H13V10ZM13 13H7V15H13V13Z"
        fill="#2D2A5C"
      />
    </SvgIcon>
  );
};

export const Doc = (props: SvgIconProps): JSX.Element => {
  return (
    <SvgIcon {...props}>
      <path
        d="M12 0H2C0.9 0 0.00999999 0.9 0.00999999 2L0 16C0 17.1 0.89 18 1.99 18H16C17.1 18 18 17.1 18 16V6L12 0ZM5 14C4.45 14 4 13.55 4 13C4 12.45 4.45 12 5 12C5.55 12 6 12.45 6 13C6 13.55 5.55 14 5 14ZM5 10C4.45 10 4 9.55 4 9C4 8.45 4.45 8 5 8C5.55 8 6 8.45 6 9C6 9.55 5.55 10 5 10ZM5 6C4.45 6 4 5.55 4 5C4 4.45 4.45 4 5 4C5.55 4 6 4.45 6 5C6 5.55 5.55 6 5 6ZM11 7V1.5L16.5 7H11Z"
        fill="#2D2A5C"
      />
    </SvgIcon>
  );
};

export const Building = (props: SvgIconProps): JSX.Element => {
  return (
    <SvgIcon {...props}>
      <path d="M5 9H2V16H5V9Z" fill="#2D2A5C" />
      <path d="M11.5 9H8.5V16H11.5V9Z" fill="#2D2A5C" />
      <path d="M20 18H0V21H20V18Z" fill="#2D2A5C" />
      <path d="M18 9H15V16H18V9Z" fill="#2D2A5C" />
      <path d="M10 0L0 5V7H20V5L10 0Z" fill="#2D2A5C" />
    </SvgIcon>
  );
};
